exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-user__profile-name{display:flex;align-items:center;margin-left:.275rem}.fts-user__profile-name .profile-username{margin-left:.375rem;color:var(--fts-gray-5)}", ""]);

// exports
